import { render, staticRenderFns } from "./BINCardRelatedList.vue?vue&type=template&id=22416159&lang=pug&"
import script from "./BINCardRelatedList.vue?vue&type=script&lang=js&"
export * from "./BINCardRelatedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports